import { ApiClientImplementation } from 'infra/api-client/api-client'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import SurgicalOrderGuidesService from 'presentation/contexts/services/surgical-order-guides-service'
import { ApiRepository } from 'repository/api-repository'
import { SurgicalOrderGuidesRepository } from 'repository/repositories/surgical-order-guides/surgical-order-guides-repository'
import { RemoteCreateSurgicalOrderGuideConsultAuthorization } from 'service/usecases/createSurgicalOrderGuideConsultAuthorization/createSurgicalOrderGuideConsultAuthorization'
import { RemoteLoadGuideItem } from 'service/usecases/load-guide-item/load-guide-item'
import { RemoteLoadSurgicalOrderGuideAuthorization } from 'service/usecases/load-surgical-order-guide-authorization/load-surgical-order-guides'
import { RemoteLoadSurgicalOrderGuides } from 'service/usecases/load-surgical-order-guides/load-surgical-order-guides'

export default function makeSurgicalOrderGuidesService() {
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(new ApiClientImplementation())
  )

  const surgicalOrderGuidesRepository = new SurgicalOrderGuidesRepository(
    apiRepository
  )
  const loadSurgicalOrderGuides = new RemoteLoadSurgicalOrderGuides(
    surgicalOrderGuidesRepository
  )

  const loadSurgicalOrderGuideAuthorization =
    new RemoteLoadSurgicalOrderGuideAuthorization(surgicalOrderGuidesRepository)

  const loadGuideItem = new RemoteLoadGuideItem(surgicalOrderGuidesRepository)

  const createSurgicalOrderGuideConsultAuthorization =
    new RemoteCreateSurgicalOrderGuideConsultAuthorization(
      surgicalOrderGuidesRepository
    )

  return new SurgicalOrderGuidesService({
    loadSurgicalOrderGuides,
    loadSurgicalOrderGuideAuthorization,
    loadGuideItem,
    createSurgicalOrderGuideConsultAuthorization
  })
}
